/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect, useRef} from 'react'
import db from '../../../services/firebase'
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  onSnapshot,
  updateDoc,
  writeBatch,
  serverTimestamp,
} from 'firebase/firestore'
import {Overlay, Popover} from 'react-bootstrap'
import {useAuth} from '../../modules/auth'
import {ViewControl} from './components/ViewControl'
import ReactPaginate from 'react-paginate'
import {Helmet} from 'react-helmet'
import {ControlListToolbar} from './components/header/ControlListToolbar'
import {useLocation} from 'react-router-dom'
import useCrispChat from '../../Hooks/useCrispChat'
import {ControlRow, FilterDropdown} from './components/table'
import {showErrorToast, showSuccessToast} from 'app/components/ShowToast'
import ConfirmationModal from 'app/components/ConfirmationModal'
import Deactivate from 'app/components/Deactivate'
import {processControlValues} from './utils/controlUtils'
import Searchbar from 'app/components/Searchbar'
import {ListLoading} from 'app/components/ListLoading'
import useAuditContext from 'app/Hooks/useAuditContext'
import Button from 'app/components/Button'
import {ToastContainer} from 'react-toastify'
import AssignOwnerForm from 'app/components/AssignOwnerForm'

type Props = {
  className: string
  blogs?: any
}

const ControlManagement: React.FC<Props> = () => {
  const [controls, setControls] = useState([] as any[])
  const [tests, setTests] = useState([] as any[])
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredItems, setFilteredItems] = useState<any[]>([])
  const [showAllFrameworks, setShowAllFrameworks] = useState(false)
  const [searchLength, setSearchLength] = useState(false)
  const [selectedFramework, setSelectedFramework] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('')
  const [selectedOwner, setSelectedOwner] = useState('')
  const [selectedAuthor, setSelectedAuthor] = useState('')
  const [filterMatch, setFilterMatch] = useState(false)
  const {currentUser} = useAuth()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [controlID, setControlID] = useState('')
  const [activeRowId, setActiveRowId] = useState('')
  const [currentPage, setCurrentPage] = useState(0)
  const [showEmptyState, setShowEmptyState] = useState<boolean>(false)
  const [selectedNumber, setSelectedNumber] = useState('100')
  let ITEMS_PER_PAGE = parseInt(selectedNumber)
  const [show1, setShow1] = useState(false)
  const [checkedItems, setCheckedItems] = useState<any[]>([])
  const [selectAll, setSelectAll] = useState<boolean>(false)
  const [personnels, setPersonnels] = useState<any[]>([])
  const overlayRef = useRef<HTMLDivElement>(null)
  const target = useRef(null)
  const [isDropdownVisible, setDropdownVisible] = useState(false)
  const [activeFrameworks, setActiveFrameworks] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const id = params.get('id')
  const [currentPlan, setPlan] = useState<any[]>([])
  const {toggleCrispChat} = useCrispChat()
  const isTrialPlan = currentPlan[0]?.account_type === 'Trial' || currentPlan[0]?.account_type === 'Trial-plus'
  const {currentAuditContext} = useAuditContext()
  const [audits, setAudits] = useState<any[]>([])
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const [showDeactivatemodel, setShowDeactivatemodel] = useState(false)
  const [deactivateId, setDeactivateId] = useState('')
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [selectedControl, setSelectedControl] = useState<any>(null)
  const [isDeleting, setIsDeleting] = useState(false)
  const [isActivateModalOpen, setIsActivateModalOpen] = useState(false)
  const [selectedActivateControl, setSelectedActivateControl] = useState<any>(null)
  const [isActivating, setIsActivating] = useState(false)
  const UPDATE_INTERVAL = 15000

  useEffect(() => {
    const tenantId = currentUser?.tenantId || ''
    if (!tenantId) {
      return
    }
    const tenantRef = doc(db, 'tenants', tenantId)
    const PolicyRef = collection(tenantRef, 'audits')

    const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
      let Data = snapshot.docs
        .map((doc) => ({
          ...doc.data(),
          id: doc.id,
          status: doc.data()?.status,
          createdAt: doc.data().createdAt,
          auditor: doc.data().auditor,
        }))
        .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        .filter((audit) => audit.status !== 'Completed')

      if (currentUser?.role === 'Auditor') {
        Data = Data.filter((audit) => audit.auditor?.id === currentUser?.uid)
      }
      setAudits(Data)
    })

    return unsubscribe
  }, [])

  useEffect(() => {
    filterData()
  }, [
    controls,
    selectedFramework,
    selectedStatus,
    selectedOwner,
    selectedAuthor,
    searchTerm,
    isTrialPlan,
  ])

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target as Node) && show1) {
        setShow1(false)
      }
    }

    if (show1) {
      document.addEventListener('mousedown', handleOutsideClick)
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [show1])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowEmptyState(true)
    }, 2000)
    return () => clearTimeout(timeoutId)
  }, [])

  useEffect(() => {
    if (id) {
      setControlID(id)
      setIsModalOpen(true)
    }
  }, [id])

  useEffect(() => {
    const tenantId = currentUser?.tenantId || ''
    if (!tenantId) {
      return
    }
    const tenantRef = doc(db, 'tenants', tenantId)
    const PolicyRef = collection(tenantRef, 'employees')

    const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
      const risksData = snapshot.docs
        .map((doc) => ({
          ...doc.data(),
          id: doc.id,
          end_date: doc.data().end_date,
          plan: doc.data().plan,
          uid: doc.data().uid,
        }))
        .filter((data) => !data.end_date)
      setPersonnels(risksData)

      const filter = risksData.filter((f) => f.uid === currentUser?.uid)
      setPlan(filter)
    })

    return unsubscribe
  }, [currentUser?.tenantId, currentUser?.uid])

  useEffect(() => {
    let unsubscribeFrameworks: (() => void) | undefined

    const setupFrameworkSubscription = async () => {
      try {
        const tenantId = currentUser?.tenantId
        if (!tenantId) {
          setActiveFrameworks([])
          setTests([])
          setIsLoading(false)
          return
        }

        const tenantRef = doc(db, 'tenants', tenantId)
        const frameworksCollectionRef = collection(tenantRef, 'active_frameworks')

        unsubscribeFrameworks = onSnapshot(
          frameworksCollectionRef,
          (snapshot) => {
            const frameworksData = snapshot.docs.map((doc) => ({
              ...doc.data(),
              id: doc.id,
              frameworks: doc.data().frameworks,
            }))

            const frameworks = frameworksData[0]?.frameworks || []
            setActiveFrameworks(frameworks)
            setIsLoading(false)
          },
          (error) => {
            console.error('Firestore subscription error:', error)
            setIsLoading(false)
          }
        )
      } catch (error) {
        console.error('Setup subscription error:', error)
        setIsLoading(false)
      }
    }

    setupFrameworkSubscription()

    return () => {
      if (unsubscribeFrameworks) {
        unsubscribeFrameworks()
      }
    }
  }, [currentUser?.tenantId])

  useEffect(() => {
    let unsubscribeControls: (() => void) | undefined
    let unsubscribeTests: (() => void) | undefined

    const getControls = () => {
      try {
        const tenantId = currentUser?.tenantId || ''
        if (!tenantId || activeFrameworks.length === 0) {
          return
        }

        const tenantRef = doc(db, 'tenants', tenantId)
        const testsCollectionRef = collection(tenantRef, 'controls')
        const testsRef = collection(tenantRef, 'tests')

        unsubscribeTests = onSnapshot(testsRef, (snapshot) => {
          const testsData = snapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
            status: doc.data().status,
          }))
          setTests(testsData)
        })

        unsubscribeControls = onSnapshot(testsCollectionRef, (snapshot) => {
          const controlsData = snapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
            framework: doc.data().control_framework_mappings,
            status: doc.data().control_evidence_status,
            author: doc.data().author,
            control_title: doc.data().control_title,
            control_framework_mappings: doc.data().control_framework_mappings,
          }))

          const filteredControls = controlsData.filter((control) => {
            if (control.author === 'Custom Control') return true

            if (!control.framework) return false

            if (currentUser?.role === 'Auditor' && audits.length > 0) {
              const auditFrameworks = audits.flatMap((audit) => audit.framework || [])
              if (auditFrameworks.length === 0) return false

              return auditFrameworks.some(
                (framework) =>
                  control.framework.startsWith(framework) &&
                  !control.framework.startsWith('ISO 27001:2013')
              )
            } else if (currentAuditContext) {
              return currentAuditContext.framework.some(
                (framework) =>
                  control.framework.startsWith(framework) &&
                  !control.framework.startsWith('ISO 27001:2013')
              )
            } else {
              return activeFrameworks.some(
                (framework) =>
                  control.framework.startsWith(framework) &&
                  !control.framework.startsWith('ISO 27001:2013')
              )
            }
          })

          const sortedControls = [...filteredControls].sort((a, b) =>
            (a.control_title || '').localeCompare(b.control_title || '')
          )

          const maskTitle = (title) => {
            if (!title || title.length <= 9) return '****'
            const visibleStart = title.slice(0, 4)
            const visibleEnd = title.slice(-3)
            const middleSection = title.slice(5, -4)
            const maskedMiddle = [...middleSection]
              .map((char) => (char === ' ' ? ' ' : '*'))
              .join('')
            return `${visibleStart}${maskedMiddle}${visibleEnd}`
          }

          const maskField = (field) => {
            if (!field || field.length <= 5) return '*****'
            return `${field.slice(0, 2)}****${field.slice(-1)}`
          }

          if (currentUser?.account_type === 'Trial' || currentUser?.account_type === 'Trial-plus') {
            const maskedControls = sortedControls.map((control, index) => {
              if (index < 5) {
                return control
              }
              return {
                ...control,
                control_title: maskTitle(control.control_title),
                control_description: '****',
                control_objective: '****',
                id: maskField(control.id),
                framework: maskField(control.framework),
                status: '****',
                author: '****',
                control_framework_mappings: '****',
              }
            })
            setControls(maskedControls)
            setFilteredItems(maskedControls)
          } else {
            setControls(sortedControls)
            setFilteredItems(sortedControls)
          }
          setSearchLength(filteredControls.length === 0)
        })
      } catch (error) {
        console.error('Error getting controls:', error)
      }
    }

    if (activeFrameworks.length > 0 || (currentUser?.role === 'Auditor' && audits.length > 0)) {
      getControls()
    }

    return () => {
      if (unsubscribeControls) {
        unsubscribeControls()
      }
      if (unsubscribeTests) {
        unsubscribeTests()
      }
    }
  }, [
    activeFrameworks,
    currentUser?.tenantId,
    currentUser?.account_type,
    currentUser?.role,
    audits,
  ])

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node) && isOpen) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick)
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [isOpen])

  const toggleDropdown2 = () => {
    setIsOpen(!isOpen)
  }

  const handleOpenModal = (id) => {
    setDropdownVisible(false)
    setIsModalOpen(true)
    if (!id) {
      return
    }
    setControlID(id)
    setActiveRowId(id)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setActiveRowId('')
  }

  const applyFilters = (baseControls: any[], searchTerm: string = '') => {
    return baseControls.filter((control) => {
      let matchesFramework = true
      let matchesStatus = true
      let matchesOwner = true
      let matchesAuthor = true
      let matchesSearch = true

      if (selectedFramework) {
        const mappings = control.control_framework_mappings
        matchesFramework =
          mappings && typeof mappings === 'string' ? mappings.includes(selectedFramework) : false
      }

      if (selectedStatus) {
        if (selectedStatus === 'OK') {
          matchesStatus = control.control_evidence_status === 'OK'
        } else if (selectedStatus === 'Unhealthy') {
          matchesStatus = control.control_evidence_status === 'Unhealthy'
        } else if (selectedStatus === 'Deactivated') {
          matchesStatus = control.control_evidence_status === 'Deactivated'
        }
      }

      if (selectedOwner) {
        matchesOwner = control.control_owner === selectedOwner
      }

      if (selectedAuthor) {
        if (selectedAuthor === 'SecureSlate') {
          matchesAuthor = !control.author || control.author === 'SecureSlate'
        } else {
          matchesAuthor = control.author === selectedAuthor
        }
      }

      if (searchTerm) {
        matchesSearch = control.control_title.toLowerCase().includes(searchTerm.toLowerCase())
      }

      return matchesFramework && matchesStatus && matchesOwner && matchesAuthor && matchesSearch
    })
  }

  useEffect(() => {
    let filteredData = controls

    if (isTrialPlan) {
      if (searchTerm || selectedFramework || selectedStatus || selectedOwner || selectedAuthor) {
        filteredData = applyFilters(filteredData.slice(0, 5), searchTerm)
      } else {
        filteredData = controls
      }
    } else {
      filteredData = applyFilters(filteredData, searchTerm)
    }

    setFilteredItems(filteredData)
    setSearchLength(filteredData.length === 0)
  }, [
    controls,
    searchTerm,
    selectedFramework,
    selectedStatus,
    selectedOwner,
    selectedAuthor,
    isTrialPlan,
  ])

  const handleReseta = () => {
    setSelectedFramework('')
    setSelectedStatus('')
    setSelectedOwner('')
    setSelectedAuthor('')
    setFilteredItems(controls)
    setFilterMatch(false)
    setIsOpen(false)
  }
  const handleResetClick = () => {
    handleReseta()
  }

  const pageCount = Math.ceil(filteredItems.length / ITEMS_PER_PAGE)

  const handlePageClick = ({selected}: {selected: number}) => {
    setCurrentPage(selected)
    window.scrollTo({top: 0, behavior: 'smooth'})
  }

  const offset = currentPage * ITEMS_PER_PAGE
  const sortedControls = filteredItems
  const paginatedData = sortedControls.slice().slice(offset, offset + ITEMS_PER_PAGE)

  const handleDeselectClick = () => {
    setCheckedItems([])
    setSelectAll(false)
  }

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked
    setSelectAll(isChecked)
    setCheckedItems(isChecked ? filteredItems.map((item) => item.id) : [])
  }

  const handleCheckChange = (e) => {
    const {checked, value} = e.target
    setCheckedItems((prev) => {
      const newCheckedItems = checked ? [...prev, value] : prev.filter((item) => item !== value)
      setSelectAll(newCheckedItems.length === filteredItems.length)
      return newCheckedItems
    })
  }

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible)
  }

  const handleDeactivateControl = async (control) => {
    setShowDeactivatemodel(true)
    setDeactivateId(control.id)
  }

  const handleDeactivate = () => {
    setShowDeactivatemodel(false)
  }

  const handleDeleteClick = async (control) => {
    setSelectedControl(control)
    setIsDeleteModalOpen(true)
  }

  const handleConfirmDelete = async () => {
    if (!selectedControl) return

    setIsDeleting(true)
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const policyRef = collection(tenantRef, 'controls')
      const docRef = doc(policyRef, selectedControl.id)
      await deleteDoc(docRef)

      if (selectedControl.risk_scenario && selectedControl.risk_scenario.length > 0) {
        const riskUpdates = selectedControl.risk_scenario.map(async (risk) => {
          const riskRef = doc(collection(tenantRef, 'risks'), risk.riskId)

          const riskDoc = await getDoc(riskRef)
          if (riskDoc.exists()) {
            const riskData = riskDoc.data()

            const updatedAddedControls = riskData.added_controls.filter(
              (addedControl) => addedControl.id !== selectedControl.id
            )

            await updateDoc(riskRef, {
              added_controls: updatedAddedControls,
            })
          }
        })

        await Promise.all(riskUpdates)
      }

      setIsDeleteModalOpen(false)
      setSelectedControl(null)
      setIsDeleting(false)
      showSuccessToast({message: 'Control deleted successfully'})
    } catch (error) {
      setIsDeleting(false)
      showErrorToast({
        message: 'An error occurred while deleting the control and updating associated risks.',
      })
    }
  }

  const filterData = () => {
    let filteredData = applyFilters(controls, searchTerm)
    setFilteredItems(filteredData)
    setFilterMatch(filteredData.length === 0)
  }
  const activeFilterCount = [
    selectedFramework,
    selectedStatus,
    selectedOwner,
    selectedAuthor,
  ].filter(Boolean).length

  const handleActivateControl = async (control) => {
    setSelectedActivateControl(control)
    setIsActivateModalOpen(true)
  }

  const handleConfirmActivate = async () => {
    if (!selectedActivateControl) return

    setIsActivating(true)
    try {
      const newStatus =
        selectedActivateControl.control_evidence_status === 'Deactivated'
          ? 'Incomplete'
          : 'Deactivated'
      const action =
        selectedActivateControl.control_evidence_status === 'Deactivated'
          ? 'activate'
          : 'deactivate'

      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/controls/${selectedActivateControl.id}`)
      await updateDoc(testDocRef, {
        control_evidence_status: newStatus,
        deactivation_control: '',
      })

      showSuccessToast({message: `${selectedActivateControl.control_title} has been ${action}d.`})
    } catch (error) {
      const action =
        selectedActivateControl.control_evidence_status === 'Deactivated'
          ? 'activating'
          : 'deactivating'
      showErrorToast({message: `An error occurred while ${action} the control.`})
    } finally {
      setIsActivating(false)
      setIsActivateModalOpen(false)
      setSelectedActivateControl(null)
    }
  }

  const checkAndUpdateAllControlStatuses = async () => {
    try {
      const batch = writeBatch(db)
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      let hasUpdates = false

      for (const control of controls) {
        if (control.control_evidence_status === 'Deactivated') continue

        const controlTests = tests.filter(
          (test) => control.test_id?.includes(test.id) && test.status !== 'Deactivated'
        )
        const controlDocuments = tests.filter(
          (doc) => control.document_id?.includes(doc.id) && doc.status !== 'Deactivated'
        )

        const testPassed = controlTests.filter((test) => test.status === 'Pass').length
        const testTotal = controlTests.length
        const docPassed = controlDocuments.filter((doc) => doc.status === 'Pass').length
        const docTotal = controlDocuments.length

        const totalPassed = testPassed + docPassed
        const totalItems = testTotal + docTotal

        const newStatus =
          (totalPassed === totalItems && totalItems > 0) || totalItems === 0 ? 'OK' : 'Unhealthy'

        if (newStatus !== control.control_evidence_status) {
          const controlRef = doc(tenantRef, 'controls', control.id)
          batch.update(controlRef, {
            control_evidence_status: newStatus,
            last_updated: serverTimestamp(),
          })
          hasUpdates = true
        }
      }

      if (hasUpdates) {
        await batch.commit()
      }
    } catch (error) {
      console.error('Error updating control statuses:', error)
    }
  }

  useEffect(() => {
    if (controls.length > 0 && tests.length > 0) {
      const updateTimeout = setTimeout(() => {
        checkAndUpdateAllControlStatuses()
      }, UPDATE_INTERVAL)

      return () => clearTimeout(updateTimeout)
    }
  }, [controls, tests])

  return (
    <>
      <Helmet>
        <title>SecureSlate | Controls</title>
      </Helmet>
      <div className='card-header border-0 pt-6'>
        <div className='flex-lg-fill'>
          <Searchbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>
        <div className='card-toolbar'>
          {checkedItems.length > 0 ? (
            <>
              <div className='border-end pe-4 text-center text-gray-900'>
                <span>
                  <p className='pt-4'>{checkedItems.length} Selected</p>
                </span>
              </div>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <div className='mx-5' style={{cursor: 'pointer'}} onClick={handleDeselectClick}>
                  <img src='/media/buttons/Deselect.svg' alt='Deselect' />
                </div>

                <div className='mb-1' style={{cursor: 'pointer'}} ref={target}>
                  <Button
                    btnType='primary'
                    onClick={() => setShow1(!show1)}
                    disabled={currentUser?.role === 'Auditor' || !!currentAuditContext}
                  >
                    Assign Owner
                  </Button>
                </div>
                <Overlay
                  show={show1}
                  target={target.current}
                  placement='bottom'
                  container={document.body}
                  containerPadding={10}
                >
                  {(props) => (
                    <Popover id='popover-contained' {...props}>
                      <div ref={overlayRef as React.RefObject<HTMLDivElement>}>
                        <Popover.Body onClick={(e) => e.stopPropagation()}>
                          <AssignOwnerForm
                            personnels={personnels}
                            checkedItems={checkedItems}
                            onClose={() => setShow1(false)}
                            onSuccess={() => {
                              setCheckedItems([])
                              setSelectAll(false)
                            }}
                            currentUser={currentUser}
                            collectionName='controls'
                            fieldName='control_owner'
                          />
                        </Popover.Body>
                      </div>
                    </Popover>
                  )}
                </Overlay>
              </div>
            </>
          ) : (
            <>
              <FilterDropdown
                isOpen={isOpen}
                activeFilterCount={activeFilterCount}
                toggleDropdown2={toggleDropdown2}
                selectedFramework={selectedFramework}
                setSelectedFramework={setSelectedFramework}
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                selectedOwner={selectedOwner}
                setSelectedOwner={setSelectedOwner}
                personnels={personnels}
                selectedAuthor={selectedAuthor}
                setSelectedAuthor={setSelectedAuthor}
                handleResetClick={handleResetClick}
                filterData={filterData}
                dropdownRef={dropdownRef as React.RefObject<HTMLDivElement>}
              />
              <ControlListToolbar />
            </>
          )}
        </div>
      </div>
      <Deactivate isOpen={showDeactivatemodel} onClose={handleDeactivate} id={deactivateId} />

      <div className='card-body pt-4'>
        <div className='table-responsive'>
          <table className='table table-row-gray-300 align-middle gs-0 gy-4 table-hover'>
            <thead>
              <tr
                className='fw-bold'
                style={{color: '#5A5A5A', borderBottom: '1px dashed #CCCCCC'}}
              >
                <th className='w-25px'>
                  {(currentUser?.account_type !== 'Trial' && currentUser?.account_type !== 'Trial-plus') && (
                    <div className='form-check form-check-sm form-check-custom form-check-solid'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={selectAll}
                        data-kt-check='true'
                        data-kt-check-target='.widget-9-check'
                        onChange={handleSelectAllChange}
                      />
                    </div>
                  )}
                </th>
                <th className='min-w-200px'>CONTROL</th>
                <th className='min-w-100px'>OWNER</th>
                <th className='min-w-100px'>STATUS</th>
                <th className='min-w-200px'>MAPPED FRAMEWORKS</th>
                <th className='min-w-100px'>TESTS</th>
                <th className='min-w-100px'>AUTHOR</th>
                <th className='min-w-50px'></th>
              </tr>
            </thead>
            <ViewControl isOpen={isModalOpen} onClose={handleCloseModal} id={controlID} />

            {isLoading ? (
              <tbody>
                <tr>
                  <td colSpan={10} className='text-center'>
                    <div
                      className='d-flex justify-content-center align-items-center text-center'
                      style={{height: '500px'}}
                    >
                      <ListLoading />
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : paginatedData && filteredItems.length > 0 ? (
              paginatedData.map((control, index) => {
                if (isTrialPlan && index < 5) {
                  return (
                    <tbody key={index}>
                      <ControlRow
                        control={control}
                        index={index}
                        isTrialPlan={isTrialPlan}
                        activeRowId={activeRowId}
                        selectAll={selectAll}
                        checkedItems={checkedItems}
                        currentUser={currentUser}
                        showAllFrameworks={showAllFrameworks}
                        handleCheckChange={handleCheckChange}
                        handleOpenModal={handleOpenModal}
                        toggleDropdown={toggleDropdown}
                        handleDeleteClick={handleDeleteClick}
                        handleActivateControl={handleActivateControl}
                        handleDeactivateControl={handleDeactivateControl}
                        setShowAllFrameworks={setShowAllFrameworks}
                        tests={tests}
                        processControlValues={processControlValues}
                        currentAuditContext={currentAuditContext}
                      />
                    </tbody>
                  )
                } else if (isTrialPlan && index === 5) {
                  return (
                    <tbody key='message-row'>
                      <tr>
                        <td colSpan={100}>
                          <div className='d-flex align-items-center justify-content-center gap-3 fw-semibold text-capitalize'>
                            <span>To unlock full access and view all data, please upgrade your plan.</span>
                            <Button btnType='primary' onClick={toggleCrispChat}>
                              Contact Sales
                            </Button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  )
                } else if (isTrialPlan && index >= 5) {
                  return (
                    <tbody key={index}>
                      <ControlRow
                        control={control}
                        index={index}
                        isTrialPlan={isTrialPlan}
                        activeRowId={activeRowId}
                        selectAll={selectAll}
                        checkedItems={checkedItems}
                        currentUser={currentUser}
                        showAllFrameworks={showAllFrameworks}
                        handleCheckChange={handleCheckChange}
                        handleOpenModal={handleOpenModal}
                        toggleDropdown={toggleDropdown}
                        handleDeleteClick={handleDeleteClick}
                        handleActivateControl={handleActivateControl}
                        handleDeactivateControl={handleDeactivateControl}
                        setShowAllFrameworks={setShowAllFrameworks}
                        tests={tests}
                        processControlValues={processControlValues}
                        currentAuditContext={currentAuditContext}
                      />
                    </tbody>
                  )
                } else {
                  return (
                    <tbody key={index}>
                      <ControlRow
                        control={control}
                        index={index}
                        isTrialPlan={isTrialPlan}
                        activeRowId={activeRowId}
                        selectAll={selectAll}
                        checkedItems={checkedItems}
                        currentUser={currentUser}
                        showAllFrameworks={showAllFrameworks}
                        handleCheckChange={handleCheckChange}
                        handleOpenModal={handleOpenModal}
                        toggleDropdown={toggleDropdown}
                        handleDeleteClick={handleDeleteClick}
                        handleActivateControl={handleActivateControl}
                        handleDeactivateControl={handleDeactivateControl}
                        setShowAllFrameworks={setShowAllFrameworks}
                        tests={tests}
                        processControlValues={processControlValues}
                        currentAuditContext={currentAuditContext}
                      />
                    </tbody>
                  )
                }
              })
            ) : (
              <tbody>
                <tr>
                  <td colSpan={10} className='text-center'>
                    {searchLength ? (
                      <div className='m-20'>
                        <img src='/media/buttons/emptystate.svg' alt='' />
                        <div className='m-5 fs-5'>
                          <p style={{fontWeight: 'bold'}}>No controls found</p>
                        </div>
                        <p>
                          We couldn't find any controls that match your search. Maybe try a
                          different search!
                        </p>
                      </div>
                    ) : showEmptyState && filterMatch ? (
                      <div className='m-20'>
                        <img src='/media/buttons/emptystate.svg' alt='' />
                        <div className='fs-5'>
                          <p style={{fontWeight: 'bold'}}>No filter results</p>
                        </div>
                        <p>Maybe try a different filter or reset filters</p>
                      </div>
                    ) : (
                      <div
                        className='d-flex justify-content-center align-items-center text-center'
                        style={{height: '500px'}}
                      >
                        <ListLoading />
                      </div>
                    )}
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>

      {filteredItems.length >= 15 && (
        <div className='d-flex justify-content-between'>
          <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start dt-toolbar'>
            <div>
              <select
                name='kt_permissions_table_length'
                aria-controls='kt_permissions_table'
                className='form-select mx-8'
                id='dt-length-1'
                value={selectedNumber}
                onChange={(e) => setSelectedNumber(e.target.value)}
              >
                <option value='50'>50</option>
                <option value='100'>100</option>
                <option value='150'>150</option>
              </select>
            </div>
          </div>

          <div className='d-flex justify-content-end my-5'>
            <ReactPaginate
              previousLabel={'<'}
              nextLabel={'>'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={pageCount}
              marginPagesDisplayed={1}
              pageRangeDisplayed={1}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              activeClassName={'active'}
            />
          </div>
        </div>
      )}
      <ConfirmationModal
        isModalOpen={isDeleteModalOpen}
        hideModal={() => {
          setIsDeleteModalOpen(false)
          setSelectedControl(null)
        }}
        confirmBtnClickHandler={handleConfirmDelete}
        toDeleteItemTitle={selectedControl?.control_title}
        isLoading={isDeleting}
        type='delete'
        confirmButtonText='Remove'
      />
      <ConfirmationModal
        isModalOpen={isActivateModalOpen}
        hideModal={() => {
          setIsActivateModalOpen(false)
          setSelectedActivateControl(null)
        }}
        confirmBtnClickHandler={handleConfirmActivate}
        toDeleteItemTitle={selectedActivateControl?.control_title}
        isLoading={isActivating}
        type={
          selectedActivateControl?.control_evidence_status === 'Deactivated'
            ? 'activate'
            : 'deactivate'
        }
        title={`${
          selectedActivateControl?.control_evidence_status === 'Deactivated'
            ? 'Activate'
            : 'Deactivate'
        } Control`}
        message={`Are you sure you want to ${
          selectedActivateControl?.control_evidence_status === 'Deactivated'
            ? 'activate'
            : 'deactivate'
        } ${selectedActivateControl?.control_title}?`}
        confirmButtonText={`Yes, ${
          selectedActivateControl?.control_evidence_status === 'Deactivated'
            ? 'activate'
            : 'deactivate'
        }`}
      />
      <ToastContainer />
    </>
  )
}

export {ControlManagement}
